// extracted by mini-css-extract-plugin
export default {"topMenu":"top-menu_topMenu__U68bL","badge":"top-menu_badge__rDq29","newBadge":"top-menu_newBadge__X-NAa"};